import { render } from "./module5.vue?vue&type=template&id=32e3efc8&scoped=true"
const script = {}

import "./module5.vue?vue&type=style&index=0&id=32e3efc8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e3efc8"]])

export default __exports__